const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Whether the user asked the OS to reduce motion.
 *
 * Backs `getScrollBehavior()`. Note this is NOT needed to neutralise inline
 * styles: the global rule in `src/ui/styles/_reduced-motion.scss` already beats
 * those, because an important author declaration outranks a normal inline one.
 */
export function prefersReducedMotion(): boolean {
  return Boolean(globalThis.matchMedia?.(REDUCED_MOTION_QUERY).matches);
}

/**
 * `behavior` value for `scrollIntoView`/`scrollTo`/`scrollBy`: skips the
 * animation when the user prefers reduced motion, keeping the jump instant.
 *
 * Per CSSOM-View an explicit `behavior` argument overrides the `scroll-behavior`
 * CSS property, so the global rule's `scroll-behavior: auto !important` never
 * applies to these calls and every call site has to opt out on its own.
 */
export function getScrollBehavior(): ScrollBehavior {
  return prefersReducedMotion() ? 'auto' : 'smooth';
}
